module.exports = __webpack_public_path__ + "img/cbm-logo.7dc182f7.jpg";